import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DollarSign, TrendingUp } from "lucide-react";
import { ANALYTICS_COLORS } from "../constants";

const tooltipStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  border: "1px solid #e2e8f0",
  borderRadius: "0.5rem",
};

export default function AnalyticsCharts({ processedData, planData, groupBy }) {
  const groupLabel = groupBy.charAt(0).toUpperCase() + groupBy.slice(1);

  return (
    <>
      <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-xl bg-white p-6 shadow-md">
          <h3 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900">
            <TrendingUp className="text-blue-600" size={20} />
            Subscriber Trend by {groupLabel}
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={processedData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="period" stroke="#666" />
              <YAxis stroke="#666" />
              <Tooltip formatter={(value) => [value.toLocaleString(), "Subscribers"]} contentStyle={tooltipStyle} />
              <Line type="monotone" dataKey="totalSubscribers" stroke="#0088FE" strokeWidth={2} dot={{ r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-xl bg-white p-6 shadow-md">
          <h3 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900">
            <DollarSign className="text-green-600" size={20} />
            Revenue Trend by {groupLabel}
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={processedData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="period" stroke="#666" />
              <YAxis stroke="#666" />
              <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, "Revenue"]} contentStyle={tooltipStyle} />
              <Bar dataKey="totalRevenue" fill="#00C49F" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-xl bg-white p-6 shadow-md">
          <h3 className="mb-4 text-lg font-semibold text-gray-900">Plan Distribution</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={planData}
                cx="50%"
                cy="50%"
                outerRadius={80}
                dataKey="value"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {planData.map((entry) => (
                  <Cell key={entry.name} fill={ANALYTICS_COLORS[planData.indexOf(entry) % ANALYTICS_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => [value.toLocaleString(), "Subscribers"]} contentStyle={tooltipStyle} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-xl bg-white p-6 shadow-md">
          <h3 className="mb-4 text-lg font-semibold text-gray-900">
            Free Trial vs Cancelled Recurring by {groupLabel}
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={processedData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="period" stroke="#666" />
              <YAxis stroke="#666" />
              <Tooltip contentStyle={tooltipStyle} />
              <Line type="monotone" dataKey="freeTrialUsers" stroke="#0088FE" strokeWidth={2} name="Free Trial Users" />
              <Line type="monotone" dataKey="cancelledRecurring" stroke="#FF8042" strokeWidth={2} name="Cancelled Recurring" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
}
